import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomerDetailPage from "../customers/CustomerDetailPage";

/**
 * Wrapper component for admin detail page that reuses CustomerDetailPage
 * with admin-specific navigation (basePath and baseLabel)
 */
const AdminDetailWrapper = () => {
  const location = useLocation();
  const initialUser = location.state?.user;
  const { t } = useTranslation("customers");

  return (
    <CustomerDetailPage
      initialUser={initialUser}
      basePath="/settings/admins"
      baseLabel={t("adminsPage.header.title")}
      idLabelKey="adminsPage.detail.labels.adminId"
    />
  );
};

export default AdminDetailWrapper;
